module.exports = __webpack_public_path__ + "static/img/d_icon3.ac384766.png";